import CompareProperty from './compare-property'
import ComparePropertyToggleAction from './compare-property-toggle-action'

export default CompareProperty

export { ComparePropertyToggleAction }
